import { render, staticRenderFns } from "./Shopping.vue?vue&type=template&id=27260100&scoped=true&"
import script from "./Shopping.vue?vue&type=script&lang=js&"
export * from "./Shopping.vue?vue&type=script&lang=js&"
import style0 from "./Shopping.vue?vue&type=style&index=0&id=27260100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27260100",
  null
  
)

export default component.exports